import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import city from "../../../containers/modules/master/city";

export default function CityRoute( props ) {
    const {authUser}=props
    return (
        <Route
            path="city"
            index
                element={
                  <AccessControl
                    name={"City List"}
                    auth={authUser}
                    component={city}
                  />
                }
        />
    )
}